import { DonationWUT } from '@wix/form-fields/wut';

export default DonationWUT;
